import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { hydrationActions, PersistedKey } from '../actions/hydration.actions';
import { getUserId } from '../selectors/user.selectors';
import { omitEmptyValues, readPersistedSlice, sanitizeListParams, SanitizeRules } from '../utils/hydration.utils';

@Injectable({ providedIn: 'root' })
export class PersistStorageService {
  userId!: string;

  readonly store = inject(Store);

  constructor() {
    this.store.select(getUserId).subscribe((userId) => {
      this.userId = userId ?? 'client';
    });
  }

  readAndSanitizeValues<T extends object>(key: PersistedKey, rules?: SanitizeRules<T>, watch = true): T {
    const persisted = this.userId ? readPersistedSlice<T>(key, this.userId) : null;
    const values = rules ? sanitizeListParams(persisted, rules) : omitEmptyValues((persisted ?? {}) as T);

    if (watch) {
      this.watch(key);
    }

    return values;
  }

  private watch(key: PersistedKey): void {
    queueMicrotask(() => {
      this.store.dispatch(hydrationActions.watch({ element: key, userId: this.userId }));
    });
  }
}
